module.exports = {
  v020: [{
      name: "Fidelização",
      url: "/",
      icon: "icon-star",
      variant: "danger"
      // badge: {
      //   variant: 'primary',
      //   text: 'NEW'
      // }
    },
    {
      title: true,
      name: "Gestão",
      class: "",
      wrapper: {
        element: "",
        attributes: {}
      }
    },
    {
      name: "Relatórios",
      url: "/relatorios",
      icon: "icon-doc"

    },
    {
      name: "Análises",
      url: "/analises",
      icon: "icon-chart",
      children: [{
          name: "Produtos",
          url: "/analises/produtos",
          icon: "icon-chart"
        },
        {
          name: "Clientes",
          url: "/analises/clientes",
          icon: "icon-chart"
        }
      ]
    },
    {
      name: "Produtos",
      url: "/produtos",
      icon: "icon-list"
    },
    {
      name: "Vendas",
      url: "/vendas",
      icon: "icon-basket"
    },
    {
      title: true,
      name: "Financeiro",
      class: "",
      wrapper: {
        element: "",
        attributes: {}
      }
    },
    {
      name: "Faturas",
      url: "/faturas",
      icon: "icon-doc"
    },
    {
      title: true,
      name: "Aplicativo",
      class: "",
      wrapper: {
        element: "",
        attributes: {}
      }
    },
    {
      name: "Promoções",
      url: "/promocoes",
      icon: "icon-fire"
    },
    {
      name: "Sorteios",
      url: "/sorteios",
      icon: "icon-trophy"
    },
    {
      name: "Cardapio",
      url: "/cardapio",
      icon: "icon-book-open"
    },
    {
      name: "Banner",
      url: "/banner",
      icon: "icon-picture"
    },
    {
      name: "Campanhas",
      url: "/campanhas",
      icon: "icon-bell"
    },
    {
      name: "Cupons",
      url: "/cupons",
      icon: "icon-tag"
    },
    {
      name: "Interesses",
      url: "/interesses",
      icon: "icon-grid"
    },
    {
      name: "Clientes",
      url: "/clientes",
      icon: "icon-user"
    },
    {
      title: true,
      name: "",
      class: "",
      wrapper: {
        element: "",
        attributes: {}
      }
    }
  ],
  v013: [{
      name: "Fidelização",
      url: "/",
      icon: "icon-star",
      variant: "danger"
      // badge: {
      //   variant: 'primary',
      //   text: 'NEW'
      // }
    },
    {
      title: true,
      name: "Gestão",
      class: "",
      wrapper: {
        element: "",
        attributes: {}
      }
    },
    {
      name: "Relatórios",
      url: "/relatorios",
      icon: "icon-doc"
    },
    {
      title: true,
      name: "Aplicativo",
      class: "",
      wrapper: {
        element: "",
        attributes: {}
      }
    },
    {
      name: "Promoções",
      url: "/promocoes",
      icon: "icon-fire"
    },
    {
      name: "Sorteios",
      url: "/sorteios",
      icon: "icon-trophy"
    },
    {
      name: "Campanhas",
      url: "/campanhas",
      icon: "icon-bell"
    },
    {
      name: "Cupons",
      url: "/cupons",
      icon: "icon-tag"
    },
    {
      name: "Interesses",
      url: "/interesses",
      icon: "icon-grid"
    },
    {
      name: "Clientes",
      url: "/clientes",
      icon: "icon-user"
    },
    {
      title: true,
      name: "",
      class: "",
      wrapper: {
        element: "",
        attributes: {}
      }
    }
  ]
}
